import React from "react";
import { useDispatch } from "react-redux";
import { setTableCheckTrueFetch } from "../../features/action/fetchStorage";
import { checkFalse, checkOUT, checkTrue } from "../../util/icon";

const Tables = ({ i }) => {
  const dispatch = useDispatch();
  const handleCheckChange = (orderSH, rowIndex) => {
    dispatch(setTableCheckTrueFetch(orderSH, rowIndex));
  };

  return (
    <div className="w-[99%] m-auto pb-2 ">
      <div className="flex flex-row w-full my-2 text-center text-[#9E9E9E] text-[1vw] mx-auto ">
        <div className="w-[136px] ">כמות</div>
        <div className="w-[96px] ">משטח</div>
        <div className="w-[1104px] ">תאור מוצר</div>
        <div className="w-[160px] ">מק"ט</div>
        <div className="w-[160px]"></div>
      </div>
      {i.table.map((row, key) => (
        <div
          key={key}
          className={`flex flex-row w-full h-[50px] border-solid border-2 border-[#dbdbdb] ${
            row.check ? "line-through bg-[#ececec]" : "bg-[#F9F9F9]"
          } font-rubik font-light text-[16px] leading-tight tracking-wide-5 text-[#53626B]`}
        >
          <div className="flex w-[136px] justify-center items-center">
            {row.quantity}
          </div>
          <div className="h-[40px] w-[2px] bg-[#dbdbdb] my-auto "></div>
          <div className="flex w-[96px] justify-center items-center">
            {row.location}
          </div>
          <div className="h-[40px] w-[2px] bg-[#dbdbdb] my-auto "></div>
          <div className="flex w-[1104px]  items-center justify-end px-3">
            {row.product}
          </div>
          <div className="h-[40px] w-[2px] bg-[#dbdbdb] my-auto "></div>
          <div className="flex w-[160px] justify-center items-center">
            {row.code}
          </div>
          <div className="h-[40px] w-[2px] bg-[#dbdbdb] my-auto "></div>
          <div className={`flex w-[160px] justify-center items-center ${!row.check ? "bg-[#739D00]" : "bg-[#B9CE80]"}`}
          onClick={() => handleCheckChange(i._id, key)}>
          {row.check ? checkTrue : checkFalse}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Tables;
